import { getLastUrlSegment } from '../utils';

export const windowPathname = window.location.pathname;
export const lastUrlSegment = getLastUrlSegment(windowPathname);

export const openNewBrowserTab = (link: string) => window.open(link, '_blank');
export const openInSameTab = (link: string) => window.open(link, '_self');

export const onPageReload = (callback: () => void) => {
  window.onbeforeunload = () => {
    callback();
  };
};
